export const API_URL = 'https://jumiav2.youmingtechnologies.co.ke/'; // Use https:// if your server supports HTTPS

